import type { ModalContentProps } from './modal.types'

import { styled, useStyleConfig, vui } from '../core'
import { callAll, cs } from '../utils'
import { useModalContext } from './context'

export const ModalContentBase = styled.divBox`
  display: flex;
  inset: 0px;
  position: fixed;
  z-index: 1400;
`

/** Wraps the content provided to the Modal component. */
export const ModalContent = vui<'div', ModalContentProps>((props, ref) => {
  const { className, ...rest } = props
  const context = useModalContext()
  const { onBackdropClick, zIndex } = context ?? {}
  const styles = useStyleConfig('Modal', context)

  return (
    <ModalContentBase
      className={cs('vui-modalContent', className)}
      ref={ref}
      tabIndex={-1}
      style={{ zIndex: zIndex ?? 1400 }}
      {...styles.content}
      {...rest}
      onClick={callAll(props.onClick, onBackdropClick)}
    />
  )
})

ModalContent.displayName = 'ModalContent'

export default ModalContent
